import React, {useContext, useEffect} from "react"
import AuthContext from "../../context/AuthContext";
import AdminNav from "../../components/AdminNav/AdminNav";
import useForm from "../../hooks/useForm";
import useCreditService from "../../api/services/useCreditService";
import {Form, Fields, Input} from "../../components/Form/Form";
import SelectArray from "../../components/Form/SelectArray";

const UserAdminCredits = () => {
  const {user} = useContext(AuthContext)
  const {adminStore} = useCreditService()
  const form = useForm();

  useEffect(() => {
  }, []);

  return (
    <div className="page-user-admin">
      {user && user.is_admin &&
        <>
          <AdminNav/>
          <div className="bookings-container">
            <Form>
              <Fields
                form={form}
                initData={{company_id: user.active_company_id}}
                apiService={{userStore: adminStore}}
              >
                <SelectArray
                  name="company_id"
                  label="Company/account"
                  data={user.companies}
                  dataLabelKey="legal_name"
                  dataValueKey="id"
                />
                <Input
                  name="credits"
                  label="Hoeveel credits wil je geven?"
                  type="number"
                />
              </Fields>
            </Form>
          </div>

        </>
      }
    </div>
  )
}

export default UserAdminCredits